import { FormControl, FormHelperText } from '@mui/material';
import { type Control, Controller } from 'react-hook-form';

import type { Lots_Bool_Exp } from '@graphql/__generated__/graphql';
import { RaLabel } from '@modules/_shared/components/form/RaLabel';
import { LotSelect } from '@modules/_shared/components/LotsSelect';
import { useLocale } from '@shared/hooks/locale';

export type RaLotProps = {
  control: Control<any>;
  name: string;
  label: string;
  disabled?: boolean;
  required?: boolean;
  filters?: Lots_Bool_Exp;
  limitToDevelopment?: string;
};

export const RaLot = ({
  control,
  name,
  label,
  required,
  disabled = false,
  filters,
  limitToDevelopment,
}: RaLotProps) => {
  const { t } = useLocale();
  const rules = {
    required: required ? t('This field is required') : undefined,
  };

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <FormControl fullWidth error={!!error}>
          <RaLabel label={label} required={required} />
          <LotSelect
            lotId={value}
            onChange={onChange}
            disabled={disabled}
            filters={filters}
            limitToDevelopment={limitToDevelopment}
          />
          {error?.message && <FormHelperText>{error.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
